import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
//import SidebarLeft from "../SidebarLeft";
//import SidebarRight from "../SidebarRight";
import SecondaryMenu from "../SecondaryMenu";
import toast, { Toaster } from "react-hot-toast";

function SponsorItem({ sponsor }) {
  return (
    <div className="col-4">
      <div
        style={{
          border: "1px solid darkblue",
          borderRadius: "10px",
          margin: "5px",
        }}
      >
        <div
          style={{
            height: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <a
            href={sponsor.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <img
              className="img-evento"
              src={`${serverConfig.serverUrl}/img/sponsor/${sponsor.img}`}
              alt={`Immagine ${sponsor.img}`}
              style={{
                minHeight: "50%",
                height: "auto",
                maxHeight: "90%",
                minWidth: "50%",
                width: "auto",
                maxWidth: "90%",
                display: "block",
              }}
              draggable={false} // Impedisce il trascinamento
              onDragStart={(e) => e.preventDefault()} // Impedisce l'azione di trascinamento
            />
          </a>
        </div>
        <div style={{ fontSize: "13px", padding: "5px" }}>{sponsor.text}</div>
      </div>
    </div>
  );
}

function Sponsor() {
  const [contentSponsor, setContentSponsor] = useState(null);
  /*
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_sponsor`)
      .then((response) => {
        const data = response.data;
        setContentSponsor(data);
      })
      .catch((error) => {
        alert("ERRORE | get_history");
        //console.log("HISTORY | get_history | error", error);
        toast.error("La risorsa non è al momento scaricabile");
      });
  }, []);

  /*
  return (
    <div
      className={`row home-container ${
        showSidebar ? "show-sidebar" : "hide-sidebar"
      }`}
    >
      <button
        className="show-sidebar-button"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
      </button>
      {window.innerWidth <= 992 ? (
        showSidebar ? (
          <div className="col-12">
            <SidebarLeft />
          </div>
        ) : (
          <div className={`main-content col-12`}>
            {contentSponsor != null && (
              <div className="row">
                {Object.keys(contentSponsor).map((key) =>
                  contentSponsor[key].map((sponsor, index) => (
                    <SponsorItem key={index} sponsor={sponsor} />
                  ))
                )}
              </div>
            )}
          </div>
        )
      ) : (
        <>
          <div className="col-2 sidebar-left">
            <SidebarLeft />
          </div>
          <div className={`main-content ${showSidebar ? "col-10" : "col-12"}`}>
            {contentSponsor != null && (
              <div className="row">
                {Object.keys(contentSponsor).map((key) =>
                  contentSponsor[key].map((sponsor, index) => (
                    <SponsorItem key={index} sponsor={sponsor} />
                  ))
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
  */

  const viewSponsor = (
    <>
      {contentSponsor != null && (
        <div className="row">
          {Object.keys(contentSponsor).map((key) =>
            contentSponsor[key].map((sponsor, index) => (
              <SponsorItem key={index} sponsor={sponsor} />
            ))
          )}
        </div>
      )}
    </>
  );


  
    const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);
  
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setShowSidebar(true);
      } else {
        setShowSidebar(false);
      }
    };
  
    useEffect(() => {
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

  return (
    <div>
      {/*}
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">{viewSponsor}</div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>
              {viewSponsor}
            </div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {viewSponsor}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Sponsor;
